import React from 'react';
import styled from "styled-components";

const imageData = [
    { 
    imageURL: "/twitter.png", 
    altName: "twitter", 
    linkTo: "https://twitter.com/Timi_phil" 
  },
  { 
    imageURL: "./linkedin.png", 
    altName: "linkedin", 
    linkTo: "https://www.linkedin.com/in/rotimi-ishola/" 
  },
  { 
    imageURL: "./github.png", 
    altName: "github", 
    linkTo: "https://github.com/timiphil" 
  }
];

export const Footer = () => {
   const onClick = (linkTo) => {
      window.open(linkTo);
    };
  return (
    <Wrapper>
      <ImageWrapper >
        {imageData.map(({ imageURL, altName, linkTo }) => (
        <Image 
          key={imageURL}
          src={imageURL}
          alt={altName}
          onClick={() => onClick(linkTo)} />
        ))} 
      </ImageWrapper>
      <CopyWrite>@copyright Timiphil</CopyWrite>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 182px;
  padding-top: 91px;
  gap: 20px;

  @media screen and (max-width: 390px) {
    margin-bottom: 20px;
  }
`;

const ImageWrapper = styled.div`
  display: flex;
  gap: 40px;

  @media screen and (max-width: 390px) {
    padding-top: 10px;
  }

   @media screen and (max-width: 1024px) {
    // padding-top: 16px;
   }
`;

const Image = styled.img`
  width: 30px;
  height: 30px;
  cursor: pointer;

   @media screen and (max-width: 390px) {
    cursor: pointer;
  }
`;

const CopyWrite = styled.div`
  @media screen and (max-width: 390px) {
    padding: 5px 10px;
  }

  @media screen and (max-width: 1024px) {
     margin-bottom: 140px;
   }

  @media screen and (max-width: 1024px) {
    //  margin-bottom: 800px;
   }
`;
    /* end of footer component */





